import React, { useEffect, useRef, useState } from "react"
import "./Categorytable.scss"
import CategoryApi from "Api/CategoryApi"
import { useNavigate } from "react-router-dom"
import {
  Button,
  Col,
  Input,
  Row,
  Spinner,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import DataTableLoader from "SkeletonLoader/DataTableLoader"
import { OverlayPanel } from "primereact/overlaypanel"
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { StandardPagination, StatusBadge, ActionIcon } from "components/Common";

const Categorytable = () => {
  document.title = "Category"

  const accessToken = localStorage.getItem("accessToken")
  const [catgeoryDetails, setCategoryDetails] = useState([])
  const [page, setPage] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)
  const [limit, setLimit] = useState(10)
  const navigate = useNavigate("")
  const userData = JSON.parse(localStorage.getItem("userData"))
  const permissions = userData?.permission || []
  const [loading, setLoading] = useState(true)
  const [addCategoryLoader, setAddCategoryLoader] = useState(false)
  const [filteredCategoryDetails, setFilteredCategoryDetails] = useState([])
  const [filterStatus, setFilterStatus] = useState("all")
  const op = useRef(null)
  const [selectedCategories, setSelectedCategories] = useState([])
  const toast = useRef(null)
  const [deleteModal, setDeleteModal] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [deleteOtp, setDeleteOtp] = useState('')
  const [deleteReason, setDeleteReason] = useState('')
  const [isGeneratingOtp, setIsGeneratingOtp] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)
  const [isOtpSent, setIsOtpSent] = useState(false)

  const getAllCategoryDetails = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      params: {
        limit: limit,
        page: page,
      },
    }

    CategoryApi.getAllCategory(config)
      .then(response => {
        if (response.data.status) {
          setLoading(false)
          setCategoryDetails(response.data.data)
          setTotalRecords(response.data.totalRecords)
        }
      })
      .catch(error => {
      })
  }
  const toggleSelectAll = () => {
    if (selectedCategories.length === filteredCategoryDetails.length) {
      setSelectedCategories([])
    } else {
      setSelectedCategories(filteredCategoryDetails.map(cat => cat._id))
    }
  }

  const toggleSelection = categoryId => {
    setSelectedCategories(prev =>
      prev.includes(categoryId)
        ? prev.filter(id => id !== categoryId)
        : [...prev, categoryId],
    )
  }

  const handleUpdateStatus = newStatus => {
    if (selectedCategories.length === 0) {
      toast.current.show({ severity: 'warn', summary: 'Warning', detail: 'Please select at least one category to update.', life: 3000 });
      // toast.warn("Please select at least one category to update.")
      return
    }

    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }

    const payload = {
      categoryIds: selectedCategories,
      newStatus: newStatus,
    }

    CategoryApi.updateCategoryStatus(payload, config)
      .then(response => {
        if (response.data.status) {
          toast.current.show({ severity: 'success', summary: 'Success', detail: response.data.message, life: 3000 });
          // toast.success(response.data.message)
          getAllCategoryDetails() // Refresh the list
          setSelectedCategories([]) // Clear selection
        }
      })
      .catch(error => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: error.response?.data?.message || 'Failed to update category status.', life: 3000 });
      })
  }
  useEffect(() => {
    getAllCategoryDetails()
  }, [accessToken, page, limit])

  useEffect(() => {
    if (filterStatus === "all") {
      setFilteredCategoryDetails(catgeoryDetails)
    } else {
      const filteredData = catgeoryDetails.filter(
        category => category.verifiedStatus === filterStatus,
      )
      setFilteredCategoryDetails(filteredData)
    }
  }, [filterStatus, catgeoryDetails])

  const breadcrumbItems = [
    { label: "Pixwik", link: "/" },
    { label: "Category", link: "/categoryList" },
    { label: "Category List" },
  ]
  const handleBreadcrumbClick = link => {
    if (link !== "#") {
      navigate(link)
    }
  }
  const totalPages = Math.ceil(totalRecords / limit)

  const uploadbtn = useRef()

  const handleUploadButtonClick = () => {
    uploadbtn.current.click()
  }
  const [excelLoader, setExcelLoader] = useState(false)

  const handleFileChange = event => {
    const file = event.target.files[0]
    if (!file) return
    const formData = new FormData()
    formData.append("file", file)

    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
    setExcelLoader(true)

    CategoryApi.uploadCategoryByExcel(formData, config)
      .then(res => {
        getAllCategoryDetails()
        event.target.value = ""
        setExcelLoader(false)
        // toast.success(res.data.message)
      })
      .catch(err => {
        
        event.target.value = ""
        setExcelLoader(false)
        
      })
  }
  const handleAddCategoryClick = () => {
    setAddCategoryLoader(true)
    setTimeout(() => {
      setAddCategoryLoader(false)
      navigate("/add-category")
    }, 500)
  }

  const hasPermission = (permissions, resource, method) => {
    if (!Array.isArray(permissions.permission)) {
      console.error("Permissions is not an array:", permissions)
      return false
    }

    return permissions.permission.some(
      perm =>
        perm.permissionName === resource &&
        perm.permissionType.includes(method),
    )
  }

  const handleDeleteClick = (category) => {
    setSelectedCategory(category)
    setDeleteModal(true)
    setDeleteOtp('')
    setDeleteReason('')
    setIsOtpSent(false)
  }

  const generateDeleteOtp = () => {
    if (!selectedCategory) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Category not found",
        life: 3000
      })
      return
    }

    setIsGeneratingOtp(true)
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }

    CategoryApi.generateDeleteCategoryOtp(selectedCategory.categoryCode, {}, config)
      .then(response => {
        if (response.data.status) {
          setIsOtpSent(true)
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Delete verification OTP has been sent to Admin",
            life: 3000
          })
        }
      })
      .catch(error => {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: error.response?.data?.message || "Failed to generate OTP",
          life: 3000
        })
      })
      .finally(() => {
        setIsGeneratingOtp(false)
      })
  }

  const handleDeleteCategory = () => {
    if (!deleteOtp || !deleteReason.trim()) {
      toast.current.show({
        severity: "warn",
        summary: "Warning",
        detail: "Please enter both OTP and deletion reason",
        life: 3000
      })
      return
    }

    setIsDeleting(true)
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }

    const payload = {
      otp: deleteOtp.trim(),
      reason: deleteReason.trim()
    }

    CategoryApi.deleteCategory(selectedCategory.categoryCode, payload, config)
      .then(response => {
        if (response.data.status) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Category deleted successfully",
            life: 3000
          })
          handleCloseModal()
          getAllCategoryDetails()
        }
      })
      .catch(error => {
        const errorMessage = error.response?.data?.message || "Failed to delete category"
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: errorMessage,
          life: 3000
        })

        if (errorMessage.toLowerCase().includes("invalid otp") || errorMessage.toLowerCase().includes("expired")) {
          setDeleteOtp("")
        }
      })
      .finally(() => {
        setIsDeleting(false)
      })
  }

  const handleCloseModal = () => {
    setDeleteModal(false)
    setSelectedCategory(null)
    setDeleteOtp("")
    setDeleteReason("")
    setIsOtpSent(false)
    setIsDeleting(false)
  }

  const handleOtpChange = e => {
    const value = e.target.value
    if (value.length <= 5) {
      setDeleteOtp(value)
    }
  }

  return (
    <>
      <Toast ref={toast} position="top-right" life="3000" />
      <Modal isOpen={deleteModal} toggle={handleCloseModal} centered>
        <ModalHeader toggle={handleCloseModal}>Delete Category</ModalHeader>
        <ModalBody>
          <div className="text-center">
            <i
              className="ri-delete-bin-2-line"
              style={{ fontSize: "3rem", color: "#f46a6a" }}
            />
            <h4 className="mt-3">Are you sure?</h4>
            <p className="text-muted">
              Do you really want to delete category "{selectedCategory?.categoryName}"? This action cannot be
              undone.
            </p>
            {!isOtpSent ? (
              <Button
                color="primary"
                onClick={generateDeleteOtp}
                className="mt-2"
                disabled={isGeneratingOtp}
              >
                {isGeneratingOtp ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-1" />
                    Sending...
                  </>
                ) : (
                  "Generate OTP"
                )}
              </Button>
            ) : (
              <div className="mt-3">
                <p className="text-muted mb-2">
                  Please enter the OTP sent to admin email
                </p>
                <Input
                  type="text"
                  placeholder="Enter OTP"
                  value={deleteOtp}
                  onChange={handleOtpChange}
                  className="text-center otp-input mb-3"
                  maxLength="5"
                  autoComplete="off"
                  
                />

                <div className="mt-3">
                  <label className="form-label text-start d-block">
                    Reason for Deletion
                  </label>
                  <Input
                    type="textarea"
                    placeholder="Please provide a reason for deletion"
                    value={deleteReason}
                    onChange={e => setDeleteReason(e.target.value)}
                    className="reason-input"
                    rows="3"
                    required
                  />
                </div>
              </div>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="light"
            onClick={handleCloseModal}
            disabled={isDeleting}
          >
            Cancel
          </Button>
          {isOtpSent && (
            <Button
              color="danger"
              onClick={handleDeleteCategory}
              disabled={isDeleting || !deleteOtp || !deleteReason.trim()}
            >
              {isDeleting ? (
                <>
                  <span className="spinner-border spinner-border-sm me-1" />
                  Deleting...
                </>
              ) : (
                "Delete"
              )}
            </Button>
          )}
        </ModalFooter>
      </Modal>
      <div className="category-container">
        <Row>
          <Col xs="12">
            <div className="category-list-header d-flex align-items-center justify-content-between">
              <CustomBreadCrumb data={breadcrumbItems} pageTitle="Category" handleClick={handleBreadcrumbClick} />
              {(userData.role === "admin" ||
                hasPermission(permissions, "category", "POST")) && (
                <div className="d-flex align-items-center gap-3">
                  {selectedCategories.length === 0 && (
                    <>
                      <input
                        type="file"
                        ref={uploadbtn}
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                      />
                      <Button
                        type="button"
                        color="success"
                        className="waves-effect"
                        onClick={handleUploadButtonClick}
                      >
                        {excelLoader ? (
                          <Spinner size="sm" />
                        ) : (
                          <i className="mdi mdi-microsoft-excel" />
                        )}
                      </Button>

                      <Button
                        type="button"
                        color="secondary"
                        className="waves-effect"
                        onClick={handleAddCategoryClick}
                      >
                        Add Category
                      </Button>
                    </>
                  )}

                  {selectedCategories.length > 0 && (
                    <>
                      <Button
                        type="button"
                        color="primary"
                        className="waves-effect"
                        onClick={() => handleUpdateStatus("approve")}
                      >
                        Approve
                      </Button>
                      <Button
                        type="button"
                        color="danger"
                        className="waves-effect"
                        onClick={() => handleUpdateStatus("reject")}
                      >
                        Reject
                      </Button>
                    </>
                  )}
                </div>
              )}
            </div>
            {(userData.role === "admin" ||
              hasPermission(permissions, "category", "GET")) && (
              <div className="data-table-container">
                <div className="table-responsive mt-4 mb-3">
                  {loading ? (
                    <DataTableLoader cols={10} />
                  ) : (
                    <Table className="table mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>
                          <input
                            type="checkbox"
                            onClick={toggleSelectAll}
                            checked={
                              selectedCategories.length ===
                              filteredCategoryDetails.length
                            }
                          />
                        </th>
                        <th>#</th>
                        <th>Category Name</th>
                        <th>
                          <span className="d-flex align-items-center gap-2 justify-content-center">
                            <span>Verified Status</span>
                            <span
                              onClick={e => op.current.toggle(e)}
                              style={{ cursor: "pointer" }}
                            >
                              <i className="mdi mdi-filter" />
                            </span>
                          </span>
                          <OverlayPanel ref={op}>
                            <Input
                              type="select"
                              value={filterStatus}
                              onChange={e => {
                                setFilterStatus(e.target.value)
                                op.current.hide()
                              }}
                              style={{ width: "150px" }}
                            >
                              <option value="all">All</option>
                              <option value="approve">Approved</option>
                              <option value="reject">Rejected</option>
                              <option value="pending">Pending</option>
                            </Input>
                          </OverlayPanel>
                        </th>
                        <th>Edit</th>
                        {(userData.role === "admin" ||
                          hasPermission(permissions, "category", "GET")) && (
                          <th>View</th>
                        )}
                        {(userData?.role === "admin" ||
                        hasPermission(permissions, "category", "DELETE")) && (
                        <th className="text-center">Delete</th>
                      )}
                      </tr>
                      
                    </thead>
                    <tbody>
                      {filteredCategoryDetails.map((category, index) => (
                        <tr key={category._id} className="category-table-row">
                          <td>
                            <input
                              type="checkbox"
                              checked={selectedCategories.includes(category._id)}
                              onClick={() => toggleSelection(category._id)}
                            />
                          </td>
                          <th scope="row">{(page - 1) * limit + index + 1}</th>
                          <td>{category.categoryName}</td>
                          <td className="text-center">
                            <StatusBadge status={category.verifiedStatus} />
                          </td>
                          {category.verifiedStatus === "pending" ||
                          (["approve", "reject"].includes(
                            category.verifiedStatus,
                          ) &&
                            userData?.role === "admin") ||
                          hasPermission(permissions, "category", "PUT") ? (
                            <td>
                              <ActionIcon
                                type="edit"
                                onClick={() => {
                                  navigate(
                                    `/edit-category/${category?.categoryCode}`,
                                    {
                                      state: category,
                                    },
                                  )
                                }}
                                tooltip="Edit Category"
                              />
                            </td>
                          ) : (
                            <td>
                              <ActionIcon
                                type="edit"
                                disabled={true}
                                tooltip="No Access"
                              />
                            </td>
                          )}
                          {(userData.role === "admin" ||
                            hasPermission(permissions, "category", "GET")) && (
                            <td>
                              <ActionIcon
                                type="view"
                                onClick={() => {
                                  navigate(
                                    `/view-category/${category?.categoryCode}`,
                                  )
                                }}
                                tooltip="View Category"
                              />
                            </td>
                          )}

                            {(userData.role === "admin" ||
                                hasPermission(permissions, "category", "DELETE")) && (
                                <td className="text-center">
                                <ActionIcon
                                  type="delete"
                                  onClick={() => handleDeleteClick(category)}
                                  tooltip="Delete Category"
                                />
                                  </td>
                              )}
                         
                        </tr>
                      ))}
                    </tbody>
                    </Table>
                  )}
                </div>
              </div>
            )}
            <StandardPagination
              currentPage={page}
              totalPages={totalPages}
              onPageChange={setPage}
            />
          </Col>
        </Row>
      </div>
    </>
  )
}
export default Categorytable
